// extracted by mini-css-extract-plugin
export default {"microsoft_img":"signin_microsoft_img__mKo8d","container_center":"signin_container_center__+4PKX"};